import { render, staticRenderFns } from "./StockControl.vue?vue&type=template&id=238016b1&"
import script from "./StockControl.vue?vue&type=script&lang=js&"
export * from "./StockControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports